import { createAction } from '@reduxjs/toolkit';
export const CHANGE_AUDIO_DEVICE = 'CHANGE_AUDIO_DEVICE';
export const changeAudioDeviceAction = createAction(CHANGE_AUDIO_DEVICE);